// @flow
import React, { PureComponent } from 'react';
import { asyncConnect } from '@liveauctioneers/redux-async-connect';
import { connect } from 'react-redux';
import FormattedMessage from '../../components/Formatted/FormattedMessage';
import { getBaseUrl } from '../../redux/modules/config';
import Link from '@liveauctioneers/caterwaul-components3/lib/link';
import styles from './NotFound.module.scss';

const mapStateToProps = (state, { location }) => {
    const { pathname } = location;
    return {
        baseUrl: getBaseUrl(state),
        pathname,
    };
};

type Props = {
    baseUrl: string,
    pathname: string,
};

class NotFound extends PureComponent<Props> {
    static fetchData = () => {
        return Promise.resolve({});
    };

    render() {
        const { baseUrl, pathname } = this.props;
        const url = `${baseUrl}${pathname}`;
        return (
            <div className={`${styles.container} container`}>
                <h1>404</h1>
                <p>
                    <FormattedMessage id="sorry_we_cant_find" />
                </p>
                {!!pathname && (
                    <p>
                        <i className={styles.url}>
                            &quot;
                            {url}
                            &quot;
                        </i>
                    </p>
                )}
                <Link to={baseUrl}>www.liveauctioneers.com</Link>
            </div>
        );
    }
}

export default asyncConnect([{ deferred: true, promise: NotFound.fetchData }])(connect(mapStateToProps)(NotFound));



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.js